import request from '@/utils/request'

let Ma_ygApi = {

  /*员工列表*/
  list(data) {
    return request._post('/shop/plus.ma_yg.Index/index', data);
},
/*添加员工*/
add(data) {
    return request._post('/shop/plus.ma_yg.Index/add', data);
},
/*修改员工*/
edit(data) {
    return request._post('/shop/plus.ma_yg.Index/edit', data);
},
/*删除员工*/
del(data) {
    return request._post('/shop/plus.ma_yg.Index/del', data);
},
/*员工详情*/
detail(data) {
  return request._post('/shop/plus.ma_yg.Index/detail', data);
},
/*重置密码*/
resetPassword(data) {
  return request._post('/shop/plus.ma_yg.Index/resetPassword', data);
},
/*离职*/
resign(data) {
  return request._post('/shop/plus.ma_yg.Index/resign', data);
},
/*解绑车牌*/
unbindLicense(data) {
  return request._post('/shop/plus.ma_yg.Index/unbindLicense', data);
},
/*获取计划记录*/
getPlans(data) {
  return request._post('/shop/plus.ma_yg.Index/getPlans', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.ma_yg.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.ma_yg.Setting/getSetting', data, errorback);
    },
}
export default Ma_ygApi;



// WEBPACK FOOTER //
// ./src/api/ma_yg.js